<template>
  <ASelectMenu
    v-if="options.length"
    v-model="model"
    value-attribute="code"
    :options="options.toSorted((a, b) => a.name.localeCompare(b.name))"
    color="gray"
    size="sm"
    class="border border-gray-300 dark:border-gray-700 bg-white/70 dark:bg-gray-800/75 shadow-sm shadow-gray-700/5 rounded-full sm:hover:-translate-y-0.5 duration-300"
    variant="none"
    :ui="{
      rounded: 'rounded-full',
      icon: {
        base: 'text-gray-800 dark:text-gray-400',
      },
      trailing: { padding: { sm: 'pe-[26px]' } },
    }"
  >
    <template #label>
      <AImg :src="$countryFlag(model)" class="rounded" width="24" />
    </template>

    <template #option="{ option }">
      <AImg :src="$countryFlag(option.code)" class="rounded" width="20" />
    </template>
  </ASelectMenu>
</template>

<script lang="ts" setup>
defineProps<{ options: any[] }>()
const model = defineModel<string>({ required: true })
</script>
